import { unified } from 'unified';
import parse from 'rehype-parse';
import rehype2remark from 'rehype-remark';
import stringify from 'remark-stringify';
import remarkGfm from 'remark-gfm-configurable';
import stripNarrationText from './stripNarrationText.js';
import $ from 'jquery';

const log = console.log;

const gfmOptions = {
  plugins: {
    autolinkLiteral: false
  },
  singleTilde: false
};

const processor = unified()
  .use(parse)
  .use(rehype2remark)
  .use(remarkGfm, gfmOptions)
  .use(stringify, { resourceLink: true });

export default function createAudioScript(pagesEl) {
  // create a jquery reference to the courseHTML element and remove the following elements
  const $pages = $(pagesEl);
  $pages.find('[uc-word-skip],[aria-hidden=true],[uc-dont-read]').remove();
  $pages.find('img').remove();
  $pages.find('svg').remove();
  $pages.find('input').remove();
  $pages.find('table').remove();

  // remove links selectively
  $pages.find('a').each(function () {
    const $link = $(this);
    const linkText = $link.text().trim();
    const hasNoText = !linkText || linkText.length === 0;

    if (hasNoText) {
      // Remove links that have no text content
      $link.remove();
    } else {
      // For links with text, remove the link but preserve the text
      $link.replaceWith(document.createTextNode(linkText));
    }
  });

  // remove empty heading elements
  $pages.find('h1, h2, h3, h4, h5, h6').each(function () {
    const $heading = $(this);
    const headingText = $heading.text().trim();
    if (!headingText || headingText.length === 0) {
      $heading.remove();
    }
  });

  let md = '';

  md += processor.processSync(pagesEl.innerHTML).value;

  // file names
  md = md.replace(
    /\\*==== (.+) ====\\*/g,
    '\n\n##### ====     $1     ====\n\n'
  );

  // weird empty lines
  md = md
    .replace(/(\n\\\n|\n<!--v-if-->\n|\n<!---->\n)/g, '\n\n')
    .replace(
      /(<!-- eslint-disable -->|<!--v-if-->|<!---->|<!--teleport start-->|<!--teleport end-->)+/g,
      ''
    )
    .replace(/\n\n+/g, '\n\n');

  // remove non-breaking spaces
  md = md.replace(/\u00A0/g, ' ').replace(/\u202f/g, ' ');

  // create the audio JSON from the MD
  const rows = md.trim().split(/\s*##### ====\s+/);

  const files = rows
    .map((row, i) => {
      const [name, content] = row.split(/\s+====\s+/);

      if (name && content) {
        let cleanContent = content
          .replace(/<!--v-if-->/g, '')
          .replace('\\\n\n\\', '')
          .replace(/(\\)+\n/g, '\n')
          .replace(/(\n)+/g, '\n')
          .replace(/\n$/g, '')
          .replace(/^\n/g, '');

        cleanContent = stripNarrationText(cleanContent);

        return cleanContent.length > 0
          ? {
              [name.trim().replace(/\\+(.)/g, '$1')]: cleanContent
            }
          : false;
      }

      return false;
    })
    .filter(Boolean);

  log('✔ Audio script done.');

  return JSON.stringify(files);
}
